export const ms = {
  welcome: 'selamat datang',
  logout: 'log keluar',
  trading_accounts: 'akaun trading',
  account_list: 'senarai akaun',
  create_live_account: 'buat akaun live',
  upgrade_to_live_account: 'upgrade kepada akaun live',
  create_demo_account: 'buat akaun demo',
  finance: 'kewangan',
  deposit_funds: 'deposit dana',
  withdraw_funds: 'pengeluaran dana',
  internal_transfer: 'internal transfer',
  external_transfer: 'external transfer',
  transfer_back: 'transfer balik',
  transfer_back_to_my_local_depositor: 'pindahkan semula kepada local depositor saya',
  transfer_to_external_account: 'pindahkan ke akaun external',
  payment_history: 'sejarah pembayaran',
  my_cards: 'kad saya',
  my_profile: 'profil saya',
  personal_information: 'maklumat peribadi',
  change_password: 'tukar password',
  upload_documents: 'upload dokumen',
  partner: 'partner',
  overview: 'gambaran keseluruhan',
  clients: 'klien',
  sub_ibs: 'sub ibs',
  payout: 'pembayaran',
  marketing_material: 'bahan pemasaran',
  withdrawal_history: 'sejarah penarikan',
  become_a_partner: 'menjadi partner',
  please_fill_the_following_fields: 'sila isi ruangan berikut',
  what_geographic_region: 'Apakah kawasan geografi yang akan anda sasarkan terutamanya?',
  submit: 'serahkan',
  upload_documents_notice: 'Untuk meluluskan sepenuhnya akaun anda dan boleh berdagang, <a>sila upload dokumen anda</a> dan lengkapkan profil anda',
  change_password_ta_notice: 'Mana-mana akaun dagangan baharu akan menggunakan password baharu anda. Ini tidak menjejaskan akaun dagangan semasa anda.',
  changepass_error: 'Password semasa salah, sila cuba lagi.',
  changepass_success: 'Password berjaya ditukar',
  current_password: 'password semasa',
  new_password: 'password baharu',
  confirm_new_password: 'mengesahkan password baharu',
  pending_account: 'akaun belum selesai',
  account_must_be_approved_message: 'Akaun anda mesti diluluskan sebelum membuat akaun live trading baharu.',
  new_trading_account_message: 'Akaun trading baharu berjaya dibuat',
  password_generated_for_ta: 'Password telah dijana dan dihantar ke e-mel anda untuk akaun trading baharu anda',
  new_trading_account_type_message: 'Akaun trading {type} baharu berjaya dibuat',
  choose_your_desired_trading_platform_and_settings: 'Pilih platform dan tetapan dagangan yang anda inginkan',
  select_leverage: 'pilih leverage',
  create: 'cipta',
  select_account_type: 'pilih jenis akaun',
  select_currency: 'pilih mata wang',
  no_trading_account_found: 'Tiada akaun trading ditemui.',
  bankwire_notice:
    'Terima kasih kerana menyerahkan butiran bank anda. Kami akan mendaftarkan butiran anda dengan bank kami.<br><br> Anda akan menerima butiran wayar melalui e-mel dalam masa 24 jam bersama rujukan pembayaran peribadi anda. Anda boleh menggunakan butiran ini untuk sebarang deposit masa hadapan.<br><br> <strong>PENTING:</strong> Rujukan pembayaran diperibadikan untuk satu pelanggan. Jika anda tidak menggunakan rujukan pembayaran yang anda terima, kami tidak akan dapat menerima deposit anda. Tiada pihak ketiga boleh menggunakan rujukan pembayaran yang sama.',
  deposit: 'deposit',
  account_details: 'butiran akaun',
  enter_fasapay_id: 'Sila masukkan ID Akaun Faspay anda:',
  account_id: 'ID Akaun',
  secure_id: 'ID keselamatan',
  continue: 'teruskan',
  bankwire_deposit_details_notice:
    'Bank kami memerlukan butiran bank anda untuk memproses deposit anda. Sebarang deposit yang dibuat melalui Wire Transfer akan dikembalikan ke akaun yang sama dari mana anda mendepositkan.',
  bankwire_withdrawal_details_notice:
    'Bank kami memerlukan butiran bank anda untuk memproses pengeluaran anda. Sebarang pengeluaran yang dibuat melalui Wire Transfer akan dikembalikan ke akaun yang sama dari mana anda mendepositkan.',
  bankwire_verify_account_notice: '<p>Anda perlu mengesahkan akaun anda sebelum menggunakan Bank Wire. Sila <a href="{FSROOT_URL}upload-documents">upload dokumen anda</a></p>',
  bankwire_amount_label: 'Jumlah ({minDeposit} min. deposit)',
  bank_name: 'nama bank',
  full_name: 'nama penuh',
  deposit_methods: 'kaedah deposit',
  deposit_select_ta_p: 'Sila pilih akaun trading yang anda ingin depositkan dana kepada:',
  coming_soon: 'akan datang',
  amount: 'jumlah',
  proof_of_id: 'Bukti ID',
  proof_of_id_instructions: 'Bukti ID',
  documents_must_contain_all_of_the_following_details: 'Dokumen mesti memenuhi keperluan berikut:',
  your_full_name: 'Nama penuh anda',
  a_unique_id_number: 'Nombor ID unik',
  your_birthdate: 'tarikh lahir anda',
  your_place_of_birth: 'Tempat lahir anda',
  a_visible_photo: 'Foto yang kelihatan',
  your_signature: 'Tandatangan anda',
  your_nationality: 'Kewarganegaraan anda',
  proof_of_residence_instructions: 'Sila upload bil utiliti atau penyata bank anda.',
  your_residential_address: 'Alamat kediaman anda',
  date_of_issue: 'Tarikh dikeluarkan',
  other: 'lain',
  other_documents_instructions: 'Dokumen lain yang telah diminta oleh jabatan pengesahan kami.',
  deposit_failed: 'deposit gagal',
  deposit_successful: 'deposit berjaya',
  already_logged_in: 'Sudah mendaftar masuk',
  login: 'log masuk',
  create_an_account: 'buat akaun',
  partner_clients: 'Partner - Klien',
  trades: 'perdagangan',
  client_id: 'ID Klien',
  trading_account: 'akaun trading',
  metatrader_web_client: 'pelanggan web metatrader',
  platform: 'platform',
  order: 'order',
  pair: 'pair',
  volume: 'volume',
  close_date: 'tarikh tutup',
  commission: 'komisen',
  status: 'status',
  total_commission_generated: 'jumlah komisen yang dijana',
  total_deposits: 'jumlah deposit',
  total_withdrawals: 'jumlah pengeluaran',
  date_joined: 'tarikh menyertai',
  more: 'lebih',
  banners: 'sepanduk',
  partner_marketing_material: 'Partner - Bahan pemasaran',
  partner_overview: 'Partner - Gambaran Keseluruhan',
  partner_payout: 'Partner - Pembayaran',
  partner_payout_request_message: 'Permintaan anda telah direkodkan.',
  select_your_default_payment_option: 'Pilih pilihan pembayaran default anda:',
  beneficiary_name_on_account: 'Penerima (Nama pada akaun)',
  bank_address: 'Alamat bank',
  sort_code: 'Sort code (untuk Pelanggan UK)',
  your_provider_email: 'E-mel {provider} anda',
  select: 'pilih',
  next: 'seterusnya',
  please_confirm_your_bank_details: 'Sila sahkan butiran bank anda:',
  bank: 'bank',
  sub_partners: 'Sub Partner',
  state: 'negeri',
  date: 'Tarikh',
  internal_transfer_instructions:
    'Anda boleh memindahkan dana antara akaun dagangan anda.<br> Sila masukkan jumlah transfer yang dikehendaki dan pilih akaun sumber dan destinasi.<br> Internal transfer diproses serta-merta.',
  transfer_complete: 'transfer selesai',
  transfer_from: 'transfer daripada',
  internal_transfer_processed_successfully: 'Internal transfer telah berjaya diproses.',
  external_transfer_processed_successfully: 'External transfer telah berjaya diproses.',
  select_account: 'pilih akaun',
  to: 'kepada',
  warning_currency_conversion_will_take_place: 'amaran: penukaran mata wang akan berlaku',
  transfer: 'transfer',
  account: 'akaun',
  currency: 'mata wang',
  balance: 'balance ',
  equity: 'ekuiti',
  download: 'download',
  launch: 'pelancaran',
  email: 'emel',
  password: 'password',
  forgot: 'terlupa',
  forgot_password: 'lupa password',
  risk_warning_footer:
    'Amaran risiko: Berdagang produk berleveraj seperti Forex dan CFD mungkin tidak sesuai untuk semua pelabur kerana ia membawa tahap risiko kepada modal anda. Sila pastikan anda memahami sepenuhnya risiko yang terlibat, dengan mengambil kira objektif pelaburan anda dan tahap pengalaman, sebelum berdagang, dan jika perlu dapatkan nasihat bebas. Sila baca <a href="{riskURL}">Pendedahan Risiko</a> penuh.',
  error_contact_support: 'Kesilapan telah berlaku, sila hubungi sokongan.',
  type: 'taip',
  funded: 'dibiayai',
  username: 'nama pengguna',
  company_name: 'nama syarikat',
  website: 'laman web',
  first_name: 'nama pertama',
  last_name: 'nama terakhir',
  date_of_birth: 'tarikh lahir',
  gender: 'jantina',
  phone: 'telefon',
  dial_code: 'kod dail',
  country: 'negara',
  address: 'alamat',
  year_moved_to_address: 'tahun berpindah ke alamat',
  post_code: 'kod pos',
  selected_currency: 'mata wang terpilih',
  january: 'januari',
  february: 'februari',
  march: 'mac',
  april: 'april',
  may: 'may',
  june: 'jun',
  july: 'julai',
  august: 'ogos',
  september: 'september',
  october: 'oktober',
  november: 'november',
  december: 'disember',
  already_have_an_account: 'Sudah mempunyai akaun',
  invalid_request_login_required: 'permintaan tidak sah, anda perlu log masuk dahulu.',
  register_accounttype_account: 'daftar akaun {accountType}.',
  client_type: 'jenis klien',
  individual: 'individu',
  company: 'syarikat',
  company_information: 'Maklumat Syarikat',
  company_website: 'laman web syarikat',
  complete_live_registration: 'pendaftaran live lengkap',
  title: 'tajuk',
  confirm_password: 'mengesahkan password',
  select_country: 'pilih negara',
  phone_number: 'nombor telefon',
  choose_trading_platform: 'pilih platform trading',
  select_option: 'pilih pilihan',
  day: 'hari',
  month: 'bulan',
  year: 'tahun',
  company_registration_information: 'maklumat pendaftaran syarikat',
  date_of_registration: 'tarikh pendaftaran',
  select_nationality: 'pilih kewarganegaraan',
  nationality: 'kewarganegaraan',
  select_gender: 'pilih jantina',
  male: 'lelaki',
  female: 'perempuan',
  address_line: 'talian alamat',
  city_town: 'bandar',
  state_province: 'negeri/wilayah',
  select_year: 'pilih tahun',
  year_moved_to_current_address: 'tahun berpindah ke alamat semasa',
  company_shareholders_directors: 'pemegang saham & pengarah syarikat',
  number_of_shareholders: 'bilangan pemegang saham',
  number_of_directors: 'bilangan pengarah',
  shareholder: 'pemegang saham',
  financial_information: 'maklumat kewangan',
  total_estimated_net_worth: 'jumlah anggaran nilai bersih (€)?',
  less_than_amount: 'kurang daripada {jumlah}',
  over_amount: 'melebihi {jumlah}',
  total_estimated_annual_income: 'jumlah anggaran pendapatan tahunan (€)?',
  employment_information: 'maklumat pekerjaan',
  employment_status: 'status pekerjaan',
  employed: 'bekerja',
  self_employed: 'bekerja sendiri',
  retired: 'bersara',
  student: 'pelajar',
  unemployed: 'pengangguran',
  source_of_income: 'sumber pendapatan',
  employment: 'pekerjaan',
  inheritance: 'harta pusaka',
  investment: 'pelaburan',
  trading_experience: 'pengalaman trading',
  forex_cfds_and_other_instruments: 'forex, cfd dan instrumen lain',
  yes: 'ya',
  no: 'tidak',
  lose_capital_risk:
    'Produk derivatif adalah sesuai sebagai sebahagian daripada objektif pelaburan saya dan sikap terhadap risiko dan saya dapat menilai risiko yang terlibat dalam perdagangan mereka, termasuk kemungkinan bahawa saya mungkin kehilangan semua modal saya',
  prev_pro_qualifications: 'Saya mempunyai kelayakan profesional dan/atau pengalaman kerja terdahulu dalam industri perkhidmatan kewangan',
  account_type: 'Jenis Akaun',
  choose_currency: 'pilih mata wang',
  tos_with_link: 'Saya telah membaca, memahami dan menerima terma dan syarat serta pendedahan amaran risiko <a target="_blank" href="{URL}">di sini</a>',
  registration_successful: 'pendaftaran berjaya',
  reset_password_invalid_link: 'Pautan tetapan semula anda tidak sah, sila cuba lagi atau hubungi sokongan pelanggan.',
  reset_account_password: 'set semula password akaun',
  choose_your_new_password: 'pilih password baharu anda',
  reset_password: 'menetapkan semula password',
  file_upload_failed_filename: 'upload yang diminta untuk fail {filepath} gagal.',
  withdrawal_request_success_message: 'permintaan pengeluaran anda telah berjaya',
  withdraw: 'withdrawal',
  please_fill_the_following: 'sila isi yang berikut',
  cancel: 'batalkan',
  withdraw_select_ta_p: 'Sila pilih akaun trading yang anda ingin keluarkan daripada:',
  free_margin_change_warning: 'Sila ambil perhatian bahawa pengeluaran hendaklah dibuat dengan kaedah yang sama di mana anda mendepositkan ke akaun anda.',
  you_need_an_ib_account_to_visit_this_page: 'Anda memerlukan akaun IB untuk melawat halaman ini',
  no_permission_to_to_visit_this_page: 'Anda tidak mempunyai kebenaran untuk melawat halaman ini',
  you_became_a_partner_successfully: 'Anda berjaya menjadi partner EUROTRADER!',
  note_wallet_currency_conversion_partner:
    'Sila ambil perhatian bahawa dengan menjadi partneri, mata wang dompet anda akan ditukar kepada USD dan mana-mana dana semasa akan ditukar kepada USD dengan kadar pertukaran semasa!',
  upgraded_to_a_live_account_successfully: 'Berjaya ditingkatkan kepada akaun live!',
  passwords_dont_match: 'Password tidak sepadan',
  password_rules: 'Sekurang-kurangnya 1 huruf besar, 1 huruf kecil dan 1 nombor (6 hingga 16 aksara maks)',
  please_fill: 'sila isi',
  partner_verify_first_notice: 'Untuk menjadi rakan kongsi anda perlu mengesahkan akaun anda terlebih dahulu. Sila upload dokumen anda <a href="upload-documents">di sini</a>',
  only_currency_format_allowed: 'hanya format mata wang dibenarkan',
  please_enter_your_account_id: 'Sila masukkan ID akaun anda',
  min_deposit_with_bankwire_is_amount: 'Min. deposit dengan bankwire ialah {jumlah}',
  please_select_different_tas: 'Sila pilih akaun trading yang berbeza',
  you_need_to_accept_our_tos: 'Anda perlu menerima Terma dan Syarat kami.',
  phone_is_required: 'telefon diperlukan',
  invalid_phone_number: 'nombor telefon tidak sah',
  you_must_be_over_18: 'Anda mesti berumur 18 tahun ke atas.',
  year_is_required: 'Tahun diperlukan',
  leave_page_question: 'Tinggalkan muka surat?',
  registration_exit_notice: 'Anda belum menyelesaikan pendaftaran anda. Anda mahu pergi tanpa selesai?',
  internal_server_error_support: 'Ralat internal server. Sila hubungi sokongan prlanggan',
  please_fill_all_fields: 'Sila isi semua medan',
  no_logs_found_for_this_client: 'Tiada log ditemui untuk pelanggan ini',
  no_accounts_send: 'Tiada akaun dihantar',
  internal_server_error_try_again: 'Ralat internal server. Sila cuba sebentar lagi',
  insufficient_balance: 'Baki tidak mencukupi',
  currency_conversion_connection_error: 'Tiada respons daripada pelayan penukaran mata wang, sila cuba lagi atau hubungi sokongan pelanggan.',
  currency_conversion_error: 'Ralat penukaran mata wang, sila cuba lagi atau hubungi sokongan.',
  invalid_accounts: 'Akaun tidak sah',
  withdrawal_unsuccessful_equity_message: 'Pengeluaran tidak berjaya, ekuiti tidak mencukupi pada akaun dagangan {TAID}',
  withdrawal_failed_free_margin: 'Pengeluaran gagal. Sila semak semula free margin anda.',
  pamm_copy_server_field_message: 'sila salin dan tampal alamat IP ke dalam medan "Server" dalam server MT4 anda',
  invalid_request: 'Permintaan tidak sah',
  missing_shareholders_directors: 'Kehilangan pemegang saham/pengarah',
  missing: 'hilang',
  invalid_request_passwords_do_not_match: 'Permintaan tidak sah. Passwords tidak sepadan',
  email_exists_message: 'E-mel wujud, sila cuba dengan alamat e-mel lain.',
  your_payment_method_has_already_been_set: 'Kaedah pembayaran anda telah ditetapkan. Sila hubungi sokongan pelanggan',
  payment_method_is_required_message: 'Kaedah pembayaran diperlukan. Sila cuba lagi atau hubungi sokongan',
  couldnt_find_your_account: 'Tidak dapat mencari akaun anda',
  ta_limit_error_message: 'Akaun anda telah mencapai had akaun trading({limit}) untuk {platform}.',
  error: 'ralat',
  account_created_successfully: 'akaun berjaya dibuat',
  invalid_leverage: 'leverage tidak sah',
  insufficient_data_provided: 'data yang diberikan tidak mencukupi',
  insufficient_data_provided_missing_field: 'Data yang disediakan tidak mencukupi. {field} tiada.',
  invalid_amount: 'jumlah tidak sah',
  account_taid_doesnt_exist: 'Akaun {TAID} tidak wujud',
  withdrawal_unsuccessful_equity_taid: 'Pengeluaran tidak berjaya, ekuiti tidak mencukupi pada akaun dagangan {TAID}',
  withdrawal_unsuccessful_free_margin_taid: 'Pengeluaran tidak berjaya, margin percuma tidak mencukupi pada akaun dagangan {TAID}',
  internal_server_error: 'ralat internal server',
  deposit_failed_support: 'Deposit tidak berjaya, sila hubungi sokongan pelanggan.',
  upload_documents_instructions: 'Sila berikan kami dokumen berikut.<br> Fail hendaklah dalam format PDF, JPG atau PNG dan tidak boleh melebihi 5mb.',
  total_earned: 'jumlah yang diperolehi',
  total_paid: 'jumlah dibayar',
  total_clients: 'jumlah klien',
  total_sub_ibs: 'jumlah sub ib',
  see_trading_accounts: 'lihat akaun trading',
  see_trades: 'lihat perdagangan',
  welcome_title_live: 'Terima kasih kerana membuka akaun anda dengan EUROTRADER!',
  welcome_title_demo: 'Terima kasih kerana membuka akaun demo anda dengan EUROTRADER!',
  welcome_title_ib: 'Terima kasih kerana membuka akaun Partner anda dengan EUROTRADER!',
  welcome_text_live:
    '<p>Untuk mendapatkan kelulusan pembiayaan, diluluskan dan bersedia untuk berdagang, anda perlu melengkapkan langkah berikut:</p> <ul><li>Log masuk ke Portal Pelanggan Eurotrader</li> <li>Upload dokumen anda</li> <li>Deposit akaun anda</li> <li>Mula trading!</li></ul> <p>Jika anda memerlukan sebarang bantuan, pasukan sokongan pelanggan kami yang mesra tersedia 24/5. Untuk menghubungi mereka, klik <a href="{contactURL}" target="_blank">di sini</a></p>',
  welcome_text_demo:
    '<p>Untuk mendapatkan kelulusan pembiayaan, diluluskan dan bersedia untuk berdagang, anda perlu melengkapkan langkah berikut:</p> <ul><li>Download platform MT4</li> <li>Uji kemahiran trading anda dan kelajuan pelaksanaan kami</li> <li>Log masuk ke Portal Pelanggan anda dan naik taraf kepada akaun live</li> <li>Upload dokumen anda dan deposit akaun anda</li> <li>Berdagang pasaran kewangan terbesar di dunia!</li></ul> <p>Jika anda memerlukan sebarang bantuan, pasukan sokongan pelanggan kami yang mesra tersedia 24/5. Untuk menghubungi mereka, klik <a href="{contactURL}" target="_blank">di sini</a></p>',
  welcome_text_ib:
    '<p>Untuk mendapatkan akaun Partner anda diluluskan dan bersedia untuk anda menerima URL rujukan anda, anda perlu melengkapkan langkah berikut:</p> <ul><li>Log masuk ke Portal Pelanggan</li> <li>Upload dokumen anda</li> <li>Terima URL penjejakan anda dalam bahagian "gambaran keseluruhan" dan "alat pemasaran"</li> <li>Rujuk pelanggan anda dan terima komisen!</li></ul> <p>Jika anda memerlukan sebarang bantuan, pasukan sokongan pelanggan kami yang mesra tersedia 24/5. Untuk menghubungi mereka, klik <a href="{contactURL}" target="_blank">di sini</a></p>',
  bankwire_passports_notice: 'PENTING: Pasport sebagai bukti ID diperlukan untuk membuat wire transfer.',
  tracking_links: 'pautan penjejakan',
  proof_of_residence: 'bukti tempat tinggal',
  login_to_your_account: 'log masuk ke<br> akaun anda',
  register: 'mendaftar',
  open_demo_account: 'buka akaun demo',
  create_partner_account: 'buat akaun partner',
  page_title_partner: 'Menjadi rakan partner | Eurotrader',
  ib_payout_msg_monthly_payment: 'Pembayaran dibuat setiap dua bulan melalui kaedah pilihan anda. Pembayaran akan dibuat pada hari perniagaan ke-15 dan ke-1 setiap bulan.',
  payout_selection_complete: 'Kaedah pembayaran telah dipilih.',
  home: 'rumah',
  about: 'kira-kira',
  account_types: 'jenis akaun',
  spreads: 'spread',
  funding: 'pembiayaan',
  education: 'pendidikan',
  contact: 'kenalan',
  forex_broker: 'broker forex',
  services_provided_by: 'Perkhidmatan kewangan yang disediakan oleh Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    'Eurotrade SA (Pty) Ltd (“Eurotrader”) ialah anak syarikat Eurotrade RGB Holdings Ltd (HE367109) dan merupakan penyedia perkhidmatan kewangan yang dibenarkan, dilesenkan dan dikawal oleh Financial Sector Conduct Authority (FSCA) di Afrika Selatan dengan nombor lesen FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> dengan alamat berdaftar di 74 Walmer street, Sydenham, Johannesburg, 2192, Afrika Selatan.<br><br><!-- \'Eurotrader\' ialah jenama berdaftar Eurotrade Investments RGB Ltd, a Cypriot Investment Firm (CIF) di bawah Nombor Pendaftaran HE317893, dilesenkan dan dikawal oleh Cyprus Securities and Exchange Commission (CySEC) di bawah lesen 279/15 dengan alamat berdaftar di 70, Jalan Kyrillou Loukareos, Menara Perdana Kakos, Tingkat 1, 4156 Limassol, Cyprus. Pemprosesan kad akan diselesaikan oleh Eurotrade Investments RGB Ltd.<br><br> -->Eurotrader tidak menyediakan perkhidmatan kepada penduduk dalam bidang kuasa tertentu termasuk Amerika Syarikat, Iran, Kanada, Republik Demokratik Korea, Belgium, Jepun, dan tidak bertujuan untuk pengedaran kepada, atau digunakan oleh, mana-mana orang di mana-mana negara atau bidang kuasa di mana pengedaran sedemikian atau penggunaan akan bertentangan dengan undang-undang atau peraturan tempatan.<br><br> Eurotrade SA (PTY) Ltd tidak menyasarkan pelanggan EU secara aktif.',
  footer_risk_warning:
    'Berdagang produk berleveraj seperti Forex dan CFD mungkin tidak sesuai untuk semua pelabur kerana ia membawa tahap risiko kepada modal anda. Sila pastikan anda memahami sepenuhnya risiko yang terlibat, dengan mengambil kira objektif pelaburan anda dan tahap pengalaman, sebelum berdagang, dan jika perlu dapatkan nasihat bebas. <a href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf" style="color: #e04ef8; text-decoration: underline" target="_blank">Sila baca Pendedahan Risiko penuh.</a>',
  open_live_account: 'buka akaun live',
  not_registered_with_question: 'Tidak berdaftar dengan eurotrader?',
  forgot_password_q: 'terlupa password anda?',
  pending_deposit_success: 'Operasi berjaya, deposit anda kini menunggu kelulusan',
  your_card_will_be_charged_cny: 'Kad anda akan dicaj <b>{amount}</b> CNY',
  currency_conversion_info: 'Maklumat penukaran mata wang',
  min_deposit_is_amount: 'Min. deposit ialah {jumlah}',
  min_transfer_is_amount: 'Min. transfer ialah {jumlah}',
  local_depositor: 'Local depositor',
  converted_amount: 'jumlah yang ditukar',
  from_currency: 'daripada mata wang',
  to_currency: 'kepada mata wang',
  reference_id: 'id rujukan',
  from_account: 'daripada akaun',
  to_account: 'ke akaun',
  from_date: 'dari tarikh',
  to_date: 'sehingga kini',
  target_account_id: 'id akaun sasaran',
  wallet: 'dompet',
  received: 'menerima',
  send: 'hantar',
  sender_not_a_transfer_account: 'penghantar bukan local depositor',
  withdrawal_failed_support: 'Pengeluaran tidak berjaya, sila hubungi sokongan pelanggan.',
  clear: 'jelas',
  transfer_completed_successfully: 'transfer selesai dengan jayanya',
  receive: 'menerima',
  view_trades: 'melihat dagangan',
  your_provider_account_number: 'Nombor akaun {provider} anda',
  your_bitcoin_address: 'Alamat bitcoin anda',
  your_crypto_address: 'Alamat {crypto} anda',
  destination_tag: 'Teg destinasi',
  change_trading_account_password: 'tukar password akaun trading',
  your_card_will_be_charged_thb: 'Kad anda akan dicaj <b>{amount}</b> THB',
  dashboard: 'papan pemuka',
  sent: 'dihantar',
  client_state_approved: 'diluluskan',
  client_state_pending: 'yang belum selesai',
  client_state_incomplete: 'tidak lengkap',
  open_trades: 'dagangan terbuka',
  trade_history: 'sejarah perdagangan',
  search_trades: 'carian perdagangan',
  trade_no: 'perdagangan no',
  symbol: 'simbol',
  open_price: 'open price',
  close_price: 'close price',
  datetime: 'masa tarikh',
  my_bonuses: 'bonus saya',
  bonus: 'bonus',
  conversion_progress: 'kemajuan penukaran',
  front_of_id: 'Depan ID',
  back_of_id: 'Belakang ID',
  include_account_in_bonus_program: 'Saya ingin menyertai Program Dagangan Dibiayai 111%.',
  invest_under_master_account: 'melabur di bawah akaun master',
  i_accept_the_terms_of_service: 'saya menerima Syarat Perkhidmatan',
  pamm_master_locks_withdrawals: '[pamm ini mengehadkan pengeluaran semasa perdagangan terbuka!]',
  open_p_l: 'buka p&l',
  p_l: 'P&L',
  gains_prc: 'keuntungan %',
  max_drawdown: 'maks. drawdown',
  bonus_tos_with_link: 'Saya telah membaca dan memahami <a target="_blank" href="{URL}">terma dan syarat Program Dagangan Dibiayai 111%</a> .',
  i_am_over_18: 'Saya mengisytiharkan bahawa saya berumur lebih daripada 18 (lapan belas) tahun untuk membuka Akaun ini.',
  all_time: 'setiap masa',
  last_month: 'bulan lepas',
  last_week: 'minggu lepas',
  last_3_days: '3 hari lepas',
  monthly_avg: 'purata bulanan',
  profit: 'keuntungan',
  create_and_attach: 'buat dan lampirkan',
  attach: 'lampirkan',
  create_and_attach_new_pamm_account: 'buat dan lampirkan akaun pamm baharu',
  select_a_pamm_account_to_attach: 'pilih akaun pamm untuk dilampirkan',
  enter_private_code: 'masukkan kod peribadi',
  private_code: 'kod peribadi',
  investor_link: 'Pautan Pelabur',
  i_accept_the_lpoa: 'saya terima lpoa',
  invest: 'melabur',
  view_graph: 'lihat graf',
  name: 'nama',
  search: 'cari',
  partners: 'partner',
  reject_withdrawls_during_open_trades: 'menolak pengeluaran semasa perdagangan terbuka',
  private_master_account: 'akaun master persendirian',
  minimum_deposit: 'deposit minimum',
  performance_fee: 'yuran prestasi',
  display_name: 'nama paparan',
  new_master_account: 'akaun master baharu',
  pamm_statistics: 'statistik pamm',
  pamm: 'pamm',
  volume_traded: 'jumlah dagangan',
  apply_date_range: 'gunakan julat tarikh',
  pamm_master_locks_deposits: '[pamm ini mengehadkan deposit semasa perdagangan terbuka!]',
  bitcoin: 'Bitcoin',
  register_live_account: 'daftar akaun live',
  register_partner_account: 'daftar akaun partner',
  register_demo_account: 'daftar akaun demo',
  risk_disclosure: 'pendedahan risiko',
  address_line_2: 'Alamat 2',
  skype_id: 'id skype',
  password_rules_extended:
    'Password mesti mengandungi sekurang-kurangnya: 1 huruf besar, 1 huruf kecil, 1 nombor dan satu aksara khas. Panjang kata laluan mestilah antara 8 hingga 16 aksara.',
  login_information: 'maklumat log masuk',
  director: 'pengarah',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD.',
  pmethod_bitcoin: 'BITCOIN',
  pmethod_bankwire: 'Bankwire',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ideal',
  pmethod_instant_bank_transfer: 'Transfer Bank Segera',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Dompet Jeton',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'CUP',
  pmethod_lydiax: 'Crypto',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'Trustly - Bank Wire',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'AstroPay',
  pmethod_payneteasy: 'Payneteasy',
  field_min_currency_value: 'Medan {field} mestilah {min} atau lebih.',
  method_deposit: '{method} deposit',
  method_deposit_status: '{method} status deposit',
  quick_menu: 'menu cepat',
  details: 'butiran',
  date_from: 'tarikh dari',
  date_to: 'tarikh ke',
  from: 'daripada',
  forgot_password_form_instruction: 'Sila serahkan alamat e-mel akaun anda di bawah. Anda kemudian akan menerima e-mel dengan pautan untuk menetapkan semula password anda.',
  forgot_password_submit_success_message:
    'Pautan tetapan semula password telah dihantar ke e-mel anda. Sila pergi ke e-mel anda ({email}) dan ikuti pautan untuk menukar kata laluan anda.',
  password_reset_successfully: 'Password anda telah berjaya ditetapkan semula',
  password_too_week_or_mismatch: 'Password terlalu lemah atau entri kata laluan tidak sepadan.',
  withdrawals_credit_card_remaining_amount_message: 'Untuk mengeluarkan melalui kaedah lain, anda mesti mengeluarkan {amount} kembali ke kad kredit anda dahulu.',
  withdrawals_credit_card_refund_policy_message: 'Pembekal Kad Kredit hanya membenarkan anda mengeluarkan jumlah amaun yang anda depositkan semula ke kad anda.',
  withdrawals_amount_withdrawable_message:
    'Sebanyak {amount} boleh dikeluarkan semula ke kad anda, apa-apa yang melebihi jumlah itu boleh dikeluarkan melalui salah satu kaedah kami yang lain.',
  country_blocked_for_this_method: 'Negara anda disekat untuk kaedah ini',
  copied_text_successfully: 'berjaya menyalin {teks}.',
  choose_wallet_currency: 'pilih mata wang dompet',
  pamm_master_account_created_successfully: 'Akaun master PAMM berjaya dibuat!',
  or_account_no_for_uk: 'atau Nombor Akaun (untuk Pelanggan UK)',
  issue_date: 'Tarikh keluaran',
  expiry_date: 'Tarikh luput',
  full_copy_of_the_document: 'Salinan penuh dokumen yang menunjukkan kesemua 4 penjuru',
  recent_date: 'Tarikh terkini (tidak melebihi 3 bulan)',
  your_physical_address: 'Alamat fizikal anda, sepadan dengan alamat yang telah anda gunakan semasa mendaftar untuk akaun tersebut',
  must_be_a_utility_bill: 'Mestilah Bil Utiliti (elektrik, air, internet, gas /tenaga, bil cukai majlis/sanitasi) atau Bank Statement',
  for_further_info_attach: '**Untuk dokumentasi lanjut, sila lampirkan mereka pada e-mel dan hantar ke backoffice@eurotrader.com',
  banners_ad_blocker_notice: 'Jika anda menghadapi masalah melihat sepanduk di bawah, sila lumpuhkan penyekat iklan anda',
  content_ad_blocker_notice: 'Jika anda menghadapi masalah melihat klien web, sila lumpuhkan penyekat iklan anda',
  transfer_out: 'transfer keluar',
  transfer_in: 'transfer masuk',
  done: 'selesai',
  not_required: 'tidak dikehendaki',
  wallet_balance: 'baki dompet:',
  must_agree_terms: 'Anda mesti bersetuju menerima Terma dan Syarat kami untuk membuat akaun',
  select_payment_method: 'pilih kaedah pembayaran',
  islamic_account: 'akaun Islamik',
  islamic_documents_instructions: 'Bukti iman/agama dari masjid',
  card_number: 'nombor kad',
  expiry: 'tamat tempoh',
  redeem: 'tebus',
  must_be_multiple_of_10: 'Nilai mestilah gandaan 10',
  select_starting_balance: 'Pilih baki permulaan',
  business_name: 'Nama Perniagaan',
  business_bank_wire_instructions: 'arahan bank wire perniagaan',
  error_request_failed: 'Ralat: Permintaan gagal',
  error_no_user_with_this_email: 'Ralat: Akaun dengan alamat e-mel ini tidak ditemui',
  error_too_many_password_reset_requests: 'Ralat: Terlalu banyak penetapan semula password diminta',
  error_expired_or_invalid_request: 'Ralat: Permintaan tidak sah atau tamat tempoh',
  error_insufficient_wallet_balance: 'Ralat: Baki tidak mencukupi dalam dompet',
  error_insufficient_balance_or_equity: 'Ralat: Baki atau ekuiti tidak mencukupi',
  error_pamm_master_deposit: 'Tidak boleh deposit dalam akaun master PAMM',
  error_pamm_master_withdrawal: 'Tidak boleh keluar dari akaun master PAMM',
  error_pamm_master_locked_deposits: 'Ditolak: akaun pamm master yang wang didepositkan menolak deposit semasa perdagangan terbuka.',
  error_pamm_master_locked_withdrawals: 'Ditolak: akaun pamm master yang mengeluarkan wang menolak pengeluaran semasa perdagangan terbuka.',
  error_pamm_master_minimum_deposit: 'Ditolak: Keperluan deposit minimum tuan pamm tidak dipenuhi.',
  error_live_account_already: 'Akaun anda ialah akaun langsung',
  error_min_balance_required_is: 'Baki minimum yang diperlukan untuk akaun {TAAccountType}({TAID}) ialah {min}{currency}.',
  error_transfer_same_wallet: 'Tidak boleh memindahkan dari dompet ke dompet.',
  error_transfer_same_trading_account: 'Tidak boleh memindahkan dari dan ke akaun trading yang sama.',
  error_no_deposit_bonus_account_deposit_restricted: 'Deposit kepada jenis akaun "Bonus Tanpa Deposit" tidak dibenarkan.',
  error_no_deposit_bonus_base_amount_withdrawal: 'Tidak boleh mengeluarkan jumlah asas "Bonus Tanpa Deposit".',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: 'Tidak boleh mengeluarkan "Bonus Tanpa Deposit" jika keperluan keuntungan tidak dipenuhi.',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: 'Tidak boleh mengeluarkan lebih daripada keuntungan boleh dikeluarkan maksimum.',
  upgrade_required_for_live_ta: 'Akaun pelanggan Live dan Diluluskan diperlukan sebelum akaun trading live boleh dibuka!',
  error_wallet_currency_not_allowed_for_psp: 'Mata wang dompet tidak dibenarkan untuk kaedah pembayaran ini.',
  error_invalid_or_expired_otp: 'Ralat: Dengan syarat OTP tidak sah atau tamat tempoh.',
  error_max_confirmo_withdrawal_exceeded: 'Ralat: Permintaan pengeluaran pengesahan maksimum ialah 20000 EUR/USD',
  error_max_anual_vload_withdrawal_exceeded: 'Ralat: Pengeluaran vload tahunan maksimum meminta jumlah melebihi jumlah',
  is_islamic_acc_message: 'Untuk membuat akaun Islamik, sila hantar permintaan ke backoffice@eurotrader.com untuk membantu anda selanjutnya.',
  error_invalid_voucher: 'Ralat: Baucar VLoad tidak sah atau sudah ditebus',
  error_blocked_voucher: 'Ralat: Baucar VLoad disekat kerana disyaki penipuan',
  error_voucher_data_mismatch: 'Ralat: Baucar VLoad telah ditolak kerana data akaun tidak sepadan.',
  error_vload_voucher_below_minimum: 'Ralat: Baucar Vload di bawah jumlah deposit minimum.',
  my_bank_has_a_swift_code: 'Bank saya mempunyai swift code',
  my_bank_does_not_have_a_swift_code: 'Bank saya tidak mempunyai swift code',
  bank_not_in_swift_network_instructions:
    'Jika bank anda bukan ahli rangkaian SWIFT, sila berikan kami butiran berikut mengenai bank Koresponden bank anda untuk menerima International wire:',
  correspondent_bank_name: 'Nama Bank Koresponden',
  correspondent_bank_city: 'Bandar Bank Koresponden',
  correspondent_bank_swift: 'Swift Bank Koresponden',
  proof_of_cc: 'Bukti Kad Kredit/Debit',
  front_of_cc: 'Depan kad',
  back_of_cc: 'Belakang kad',
  proof_of_cc_instructions: 'Sila upload kad kredit atau debit anda.',
  add_document: 'Tambahkan dokumen (Pilihan)',
  cc_requirements_1: 'Salinan penuh dokumen yang menunjukkan kesemua 4 penjuru.',
  cc_requirements_2:
    'Nama kad: kad yang anda akan gunakan mesti dikeluarkan atas nama anda semata-mata. Sebarang deposit yang dibuat menggunakan kad milik pihak ketiga, akan dikembalikan serta-merta.',
  cc_requirements_3: 'Tarikh Luput: tidak kurang dari 3 bulan.',
  cc_requirements_4: 'Nombor kad: Lapan nombor tengah kad mesti ditutup dengan sekeping kertas. Hanya empat digit pertama dan empat digit terakhir harus kelihatan.',
  cc_back_requirements_5: 'Kod CVV: Sila gunakan sekeping kertas untuk menutup kod CVV.',
  cc_back_requirements_6: 'Kad mesti ditandatangani.',
  click_to_add_another_document: 'Klik di atas untuk menambah satu lagi slot upload dokumen',
  add_up_to_4_extra_documents: 'Anda boleh menambah sehingga 4 dokumen tambahan',
  add_up_to_10_extra_documents: 'Anda boleh menambah sehingga 10 dokumen tambahan',
  complete_profile: 'Profil Lengkap',
  document_received: 'Dokumen anda telah diterima dan akan disemak oleh pasukan kami.',
  please_check_the_box: 'Sila semak kotak di bawah.',
  must_be_over_18: 'Anda mesti berumur lebih dari 18 tahun untuk mendaftar.',
  shareholders_must_be_over_18: 'Pemegang saham mestilah berumur lebih daripada 18 tahun untuk mendaftar.',
  directors_must_be_over_18: 'Para pengarah mestilah berumur lebih daripada 18 tahun untuk mendaftar.',
  document_req_color: 'Dokumen mestilah berwarna',
  internal_error: 'Ralat dalaman berlaku..',
  please_enter_your_email: 'Sila masukkan alamat e-mel anda.',
  do_you_want_to_transform_your_trading: 'Adakah anda ingin mengubah trading anda?',
  reset_your_password_to_transfer_your_account: 'Tetapkan semula password anda untuk memindahkan akaun anda.',
  reset_your_old_password: 'Tetapkan semula password lama anda',
  reset_password_desc: 'Disebabkan pemindahan sistem, anda dikehendaki mengemas kini password anda. Sila gunakan borang di bawah untuk menerima pautan tetapan semula kata laluan.',
  eurotrader_login: 'Log Masuk Eurotrader | Masuk ke hab perdagangan untuk meningkatkan dagangan anda',
  your_email_is_verified: 'E-mel anda telah pun disahkan.',
  click_here_to_login: 'Klik di sini untuk log masuk',
  success_email_verified: 'Berjaya, e-mel anda kini disahkan!',
  your_link_expired: 'Pautan anda telah tamat tempoh',
  click_here_to_request_verification_email: 'Klik di sini untuk meminta e-mel pengesahan baharu.',
  a_new_verification_link_send: 'Pautan pengesahan baharu telah dihantar ke alamat e-mel anda.',
  invalid_request_please_check_your_link: 'Permintaan tidak sah. Sila semak pautan anda betul dan cuba lagi.',
  invalid_verification_code: 'Kod pengesahan tidak sah',
  please_enter_amount: 'Sila masukkan jumlah yang anda ingin deposit',
  bankwire_company_desc:
    '<p>Jika anda seorang pemegang akaun bank perniagaan dan anda ingin menggunakan pilihan bank wire transfer dengan mendaftarkan akaun perniagaan anda dengan kami, sila hantarkan dokumentasi berikut kepada kami melalui e-mel ke backoffice@eurotrader.com</p><ul><li>Surat Ikatan Syarikat/Sijil Pemerbadanan</li><li>Pengarah dan Setiausaha, apabila ada</li> <li>Sijil Pemegang Saham Berdaftar/ Pemilik Tunggal.</li> <li>Memorandum dan Tataurusan Persatuan, juga dikenali sebagai Artikel</li> <li>Bukti Pengenalan dan Alamat untuk semua Pemegang Saham berdaftar, Pemilik Manfaat dan Pengarah.</li> <li>Bukti alamat yang berkaitan dengan syarikat.</li></ul> <p>Sebarang dokumen kerajaan/rasmi lain yang mengesahkan maklumat yang diminta di atas boleh dianggap mencukupi, sekiranya dokumen di atas tidak dapat disediakan dalam format sedemikian.</p>',
  bankwire_noncompany_desc:
    '<p>Ini akan log keluar anda daripada akaun peribadi anda dan mengubah hala anda ke halaman pendaftaran kami untuk akaun Syarikat.</p> <p>Adakah anda ingin meneruskan?</p>',
  please_enter_card_detail_and_amount: 'SILA MASUKKAN BUTIRAN KAD DAN JUMLAH YANG ANDA INGIN DEPOSIT',
  important: 'PENTING',
  please_note_that_the_maximum_deposit_amount: 'Sila ambil perhatian bahawa jumlah deposit maksimum setiap hari ialah $1000 setiap kad.',
  city: 'Bandar',
  zip: 'Poskod',
  please_note_that_after_three_unsuccessful_attempts:
    '* Sila ambil perhatian bahawa selepas tiga (3) percubaan yang tidak berjaya, pilihan pembayaran VISA/MASTERCARD tidak akan tersedia selama 24 jam.',
  epay_pro_desc:
    '<p>Peniaga yang dihormati<br><br> Malangnya, disebabkan oleh isu dan sekatan teknikal tertentu, Deposit Kad Kredit akan dilumpuhkan buat sementara waktu melalui pembekal kami EPayPro.<br><br> Visa &amp; Mastercard akan dilumpuhkan pada tengah malam 23:00 GMT 04/04/2018. Berikutan penyedia pembayaran dilumpuhkan, deposit akan dilumpuhkan buat sementara waktu. Walaupun pembekal pembayaran kami tidak memberikan kami jangka masa yang tepat untuk masa henti, kami sedang berusaha untuk melaksanakan alternatif secepat mungkin.<br><br> Kami sedang bekerjasama dengan pembekal kami untuk menyelesaikan isu semasa supaya pada masa hadapan, akaun boleh meneruskan pemprosesan deposit tanpa berlengah-lengah.<br><br> Sila hubungi pasukan sokongan kami sekiranya anda mempunyai sebarang pertanyaan lanjut.</p>',
  provider_redirect: 'Anda akan diubah hala ke {provider}.',
  lydiax_note: 'Deposit minimum ialah 30 EUR/USD',
  lydiax_note1:
    'Jika anda mendepositkan {crypto} bernilai kurang daripada 30 EUR/USD, anda perlu menghantar e-mel ke backoffice@eurotrader.com dan meminta bayaran balik, dengan memberikan alamat {crypto} yang ingin anda bayar balik.',
  lydiax_note2:
    'Sila masukkan jumlah {crypto} yang anda ingin depositkan untuk melihat anggaran jumlah yang anda akan dapat. Perlu diingat bahawa harga berikut hanya sah apabila ia diminta dan boleh berubah pada bila-bila masa.',
  lydiax_note3: 'Kami akan membuat alamat deposit untuk anda gunakan.',
  lydiax_note4: 'Sila gunakan alamat berikut untuk mendepositkan {crypto}.',
  lydiax_note5: 'Selepas ini, alamat unik ini akan digunakan untuk deposit anda dalam {crypto}.',
  lydiax_required_address: 'Jika dompet anda memerlukan alamat dan teg secara berasingan gunakan:',
  tag: 'Tag',
  lydiax_enter_deposit: 'SILA MASUKKAN CRYPTOCURRENCY YANG ANDA INGIN DEPOSIT',
  create_address: 'Buat alamat',
  please_note: 'Sila ambil perhatian:',
  price_estimate: 'Anggaran harga:',
  check_price: 'Semak harga',
  vload_please_enter_voucher: 'SILA MASUKKAN NOMBOR PIN BAUCAR VLOAD ANDA',
  vload_minimum: '<p>(Nilai baucar minimum yang boleh diterima ialah <b>50</b> EUR atau USD!)</p>',
  vload_vouchers: 'Saya perlu membeli Baucar VLoad',
  vload_note:
    'Buat pembayaran tanpa kerumitan melalui Visa/MasterCard serta Bank Wire Transfer.<br>Ketahui lebih lanjut tentang VLoad atau beli baucar [EUR / USD] di vload.expert.',
  vload_note1: 'Untuk boleh membuat deposit dengan VLoad, akaun anda mesti diluluskan terlebih dahulu!',
  reason: 'Sebab:',
  attempts: 'Percubaan {attempts} {maxAttempts},',
  two_more_remaining: 'tinggal dua (2) lagi',
  one_more_remaining: 'Hanya tinggal SATU (1) percubaan',
  please_contact_bank: '<br>Sila hubungi bank yang mengeluarkan kad.<br> Kad anda mungkin disekat untuk transaksi di luar negara',
  edata_success_note:
    'Sila ambil perhatian bahawa mungkin terdapat bayaran tambahan untuk deposit anda, yang dikenakan oleh bank pengeluar anda disebabkan oleh transaksi antarabangsa. Yuran ini akan menjadi caj kecil, tetapi ia akan berbeza dari bank ke bank. <br><br>Urus niaga kad kredit ini akan dipaparkan pada penyata anda sebagai“ Pengebilan Celik Teknologi ", "Pengebilan Perniagaan " atau "Pengebilan media perniagaan ".',
  you_can_try: 'anda boleh cuba lagi',
  here: 'di sini',
  safe_charged_success_message: 'Deposit anda akan diproses oleh pejabat belakang kami dalam masa 2 hari bekerja.',
  thank_you: 'Terima kasih!',
  your_deposit_successful: 'Deposit anda berjaya',
  card_redirect: 'Anda akan diubah hala untuk memasukkan kad kredit dan butiran peribadi anda.',
  bank_wire_withdrawal_note:
    'Sekiranya penolakan Bank Wire Transfer bagi pihak bank penerima kerana butiran bank yang salah diberikan oleh pelanggan, pelbagai perbelanjaan pentadbiran wayar bank yang dikenakan oleh bank yang terlibat akan ditolak daripada jumlah pengeluaran yang diminta sebelum mengkreditkan dompet pelanggan. .',
  please_enter_amount_withdraw: 'Sila masukkan jumlah yang anda ingin keluarkan',
  bitcoin_note: 'Sila masukkan alamat bitcoin anda dan jumlah yang anda ingin keluarkan',
  otp: 'Password Satu Kali (OTP)',
  otp_send_email: 'Hantar OTP ke E-mel',
  otp_additional_text: 'OTP di atas adalah untuk permintaan pengeluaran Bitcoin semasa yang anda buat',
  otp_new_password: 'Password satu kali baharu (OTP) telah dihantar ke e-mel anda',
  otp_error: 'Ralat - Gagal menghantar OTP',
  lydiax_withdrawal_note:
    'Sila masukkan amaun {currency} yang ingin anda keluarkan untuk melihat anggaran {crypto} yang anda akan dapat. Perlu diingat bahawa harga berikut hanya sah apabila ia diminta dan boleh berubah pada bila-bila masa.',
  enter_currency_amount: 'Masukkan amaun {currency} untuk menyemak anggaran',
  lydiax_withdrawal_additional_note: 'OTP di atas adalah untuk permintaan pengeluaran Crypto semasa yang anda buat',
  estimated: 'Anggaran:',
  please_enter_your_crypto_address: 'Sila masukkan alamat {crypto} anda dan jumlah yang anda ingin keluarkan',
  select_cryptocurrency: 'Pilih mata wang kripto',
  request_amount: 'Jumlah yang Diminta',
  amount_changes: 'Jumlah yang Dicaj (termasuk yuran)',
  operation_failed: 'Operasi gagal! Permintaan anda tidak sah.',
  operation_failed_error: 'Operasi gagal! Terdapat ralat memproses permintaan ini.',
  are_you_sure_create_master: 'Adakah anda pasti ingin membuat akaun baharu dan melampirkannya di bawah induk ini?',
  are_you_sure_attach_selected_account_to_master: 'Adakah anda pasti ingin melampirkan akaun yang dipilih pada induk ini?',
  change_password_desc:
    '<strong>*</strong> Perubahan password ini tidak akan menjejaskan kata laluan akaun trading anda. Sila lawati <strong>senarai akaun</strong> untuk menukar kata laluan akaun trading anda, menggunakan pilihan <strong>tukar kata laluan</strong> di bawah ikon gear.',
  client_assessment: 'PENILAIAN KLIEN',
  select_answer: 'Pilih jawapan...',
  declarations: 'AKUAN',
  complele_profile_desc:
    'Adakah anda pada masa ini, atau pernah, terlibat dalam sebarang aktiviti jenayah atau adakah terdapat sebarang pertuduhan jenayah tertunggak terhadap anda yang belum selesai di hadapan mahkamah?',
  complete_profile_desc1:
    'Adakah anda atau saudara atau rakan rapat anda seorang yang Terdedah Secara Politik? Orang Terdedah Secara Politik ialah orang asli yang telah atau telah diamanahkan dengan fungsi awam yang terkemuka dalam tempoh 12 bulan yang lalu, iaitu Ketua Negara atau kerajaan, ahli politik kanan, pegawai kanan kerajaan, pegawai kehakiman atau tentera, eksekutif kanan perbadanan milik negara, penting. pegawai parti politik.',
  are_you_us_citizen: 'Adakah anda warganegara AS atau pemastautin AS untuk tujuan cukai?',
  please_check_forms_errors: 'Sila semak borang untuk ralat!',
  profile_succesfully_completed: 'Profil berjaya dilengkapkan',
  please_select_country: 'Sila pilih Negara anda',
  set_country: 'Tetapkan negara',
  empty_country_code: 'Kod negara kosong, sila muat semula halaman dan cuba lagi.',
  invalid_country_code: 'Kod negara tidak sah, sila muat semula halaman dan cuba lagi.',
  individual_company: 'ADAKAH ANDA INDIVIDU ATAU SEBUAH SYARIKAT?',
  prev: 'SEBELUM',
  previous: 'SEBELUMNYA',
  complete: 'LENGKAP',
  please_select_an_option: 'Sila pilih pilihan untuk setiap medan!',
  swap: 'swap',
  buy: 'buy',
  sell: 'sell',
  sums: 'jumlah',
  net_total: 'JUMLAH BERSIH',
  deposit_page_desc:
    '<p class="has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold">Daftar sekarang dan</p> <p class="is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">Dapatkan <span class="has-text-white has-text-weight-bold">PERCUMA</span><br> 10 EUR/ USD<br> eBaucar</p>',
  deposit_page_desc1: 'eBaucar Bonus 10 EUR/USD akan diaktifkan sebaik sahaja anda',
  create_new_account: 'Buat Akaun baharu',
  successfully_purchase_vload: 'berjaya membeli dan menebus eVoucher VLoad daripada sebarang nilai',
  upgrade_to_tier_2: 'Naik taraf ke peringkat 2',
  register_now: 'DAFTAR SEKARANG',
  back: 'KEMBALI',
  my_card_desc: 'Di sini anda boleh melihat semua kad yang telah anda gunakan untuk pembayaran dan status semasanya dalam sistem kami.',
  you_have_no_card: 'Anda belum membuat deposit kad lagi.',
  card_no: 'Nombor kad.',
  last_used: 'Kali terakhir digunakan',
  risk_warning: 'AMARAN RISIKO',
  upload_documents_note: 'Jika anda ingin membuat deposit Kad, sila berikan tambahan dokumen berikut untuk disemak dan diluluskan.',
  please_select_your_country: 'Sila pilih negara anda dahulu',
  add_another_document: 'Tambah dokumen lain',
  drop_files_upload: 'Lepaskan fail di sini untuk di upload',
  date_until: 'Tarikh Sehingga',
  copy: 'Salinan',
  cvv: 'CVV',
  please_enter_crypto_amount: 'Masukkan jumlah {crypto}.',
  vload_pin: 'Pin VLoad',
  deposit_info:
    'Penyedia pembayaran sedang mengalami masalah teknikal dan deposit langsung Visa/Mastercard tidak tersedia pada masa ini. Sebagai alternatif, jika anda ingin membuat deposit menggunakan Visa/Mastercard anda boleh menggunakan pilihan `Vload`',
  id: 'ID',
  pamm_modal_error: 'Entri tidak sah untuk Nama Paparan. Sila jangan biarkan kosong atau masukkan lebih daripada 32 aksara',
  pamm_modal_error1: 'Nilai tidak sah dimasukkan untuk Deposit Minimum. Sila masukkan nombor bulat positif di bawah 1,000,000.',
  error_missing_required_field: 'Ralat, tiada medan yang diperlukan',
  page_not_found: 'LAMAN TIDAK DIJUMPAI',
  new_version_note: 'VERSI BAHARU DIKESAN, SILA KLIK DI SINI UNTUK SEMAKAN SEMULA',
  new_version_note1: 'Sesetengah fungsi mungkin tidak tersedia sehingga anda memuat semula halaman',
  records: 'Rekod',
  gateway: 'gateaway',
  account_no: 'Nombor akaun.',
  routing_no: 'Routing No.',
  train_up: 'LATIHAN.',
  trade_up: 'TRADE UP.',
  train_text_1: 'Bersedia untuk melabur dalam diri masa depan anda?',
  train_text_2: 'Mulakan dengan akaun demo tanpa risiko dan akses kepada sumber pembelajaran Akademi Eurotrader.',
  train_list_item_1: 'Berlatih berdagang dalam persekitaran simulasi.',
  train_list_item_2: 'Dapatkan akses kepada sumber pembelajaran terbaik dalam kelasnya.',
  train_list_item_3: 'Menjadi sebahagian daripada komuniti Eurotrader.',
  train_list_item_4: 'Ingat: tiada apa yang rugi, semuanya untuk untung.',
  form_title_1: 'AMALKAN DENGAN',
  form_title_2: 'ANDA',
  form_title_3: 'Akaun Demo',
  form_subtitle: 'Dan dapatkan akses kepada sumber pembelajaran',
  region: 'Wilayah',
  wallet_currency: 'Mata Wang Wallet',
  select_currency_label: 'Mata wang akaun demo anda',
  join: 'sertai',
  demo_account: 'Akaun Demo',
  page_title_demo: 'Buka akaun demo | Eurotrader',
  title_404: 'HEI WANG, SAYA DAH RUMAH!',
  text_line_1_404: 'Apa? Tiada sesiapa di sini untuk membantu anda melabur dalam diri masa depan anda?',
  text_line_2_404: 'Mari pulang ke rumah dan tunjukkan wang anda dari segi penghasilan anda.',
  button_404: 'PERGI BALIK',
  remember_me: 'Ingat saya',
  risk_sentence: 'Untuk melihat cara kami menggunakan data anda, sila semak data kami',
  video_courses: 'Kursus Video',
  ebooks: 'E-Books',
  knowledge_and_experience: 'ILMU DAN PENGALAMAN',
  economic_profile: 'PROFIL EKONOMI',
  product_governance: 'TADBIR URUS PRODUK',
  select_an_answer: 'Pilih jawapan',
  declarations_q1:
    'Adakah anda pada masa ini, atau pernah, terlibat dalam sebarang aktiviti jenayah atau adakah terdapat sebarang pertuduhan jenayah tertunggak terhadap anda yang belum selesai di hadapan mahkamah?',
  declarations_q2:
    'Adakah anda atau saudara atau rakan rapat anda seorang yang Terdedah Secara Politik? Orang Terdedah Secara Politik ialah orang asli yang telah atau telah diamanahkan dengan fungsi awam yang terkemuka dalam tempoh 12 bulan yang lalu, iaitu Ketua Negara atau kerajaan, ahli politik kanan, pegawai kanan kerajaan, pegawai kehakiman atau tentera, eksekutif kanan perbadanan milik negara, penting. pegawai parti politik.',
  declarations_q3: 'Adakah anda warganegara AS atau pemastautin AS untuk tujuan cukai?',
  ca_q1: '1. Adakah anda mempunyai Pengalaman berdagang?',
  ca_q2: '2. Sudah berapa lama anda melabur/berdagang dalam pasaran kewangan?',
  ca_q3: '3. Berapa banyak transaksi yang telah anda laksanakan dalam dua tahun yang lalu?<br> a. Ekuiti dan Pendapatan Tetap (Saham &amp; Bon)',
  ca_q4: '&nbsp;&nbsp; b. Forex',
  ca_q5: '&nbsp;&nbsp; c. CFD (Contracts for Differences)',
  ca_q6: '&nbsp;&nbsp; d. Produk Derivatif Lain (Warrants, Options, Rights)',
  ca_q7: '4. Apakah jumlah purata (setiap bulan) yang anda telah laburkan kepada kategori berikut?<br> a. Ekuiti dan Pendapatan Tetap (Saham &amp; Bon)',
  ca_q8: '&nbsp;&nbsp; b. Forex',
  ca_q9: '&nbsp;&nbsp; c. CFD (Contracts for Differences)',
  ca_q10: '&nbsp;&nbsp; d. Produk Derivatif Lain (Warrants, Options, Rights)',
  ca_q11: '5. Apakah jenis perkhidmatan pelaburan yang telah anda gunakan? (mengandungi pelbagai jawapan)',
  ca_q12: '6. Adakah mana-mana perkara di bawah berkenaan dengan anda? (mengandungi pelbagai jawapan)',
  ca_q13:
    '7. Saham Apple didagangkan pada harga jualan $204 dan harga belian $206. Anda membeli 100 saham Apple pada harga yang dinyatakan di atas. Apakah keuntungan/kerugian yang ditanggung pada akaun anda jika harga saham Apple bergerak pada harga jualan $190 dan harga belian $192 dan anda akan menutup kedudukan anda?',
  ca_q14:
    '8. Saham Apple didagangkan pada harga jualan $204 dan harga belian $206. Anda membuka dagangan CFD long (beli) untuk 100 kontrak (setiap kontrak menggariskan 1 bahagian Apple). Leverage yang digunakan ialah 1:5. Apakah keuntungan/kerugian yang ditanggung pada akaun anda jika harga saham Apple bergerak pada harga jualan $190 dan harga belian $192 dan anda akan menutup kedudukan anda?',
  ca_q15: '9. Menggunakan perintah stop loss:',
  ca_q16: '10. Baki akaun anda rendah. Pada masa yang manakah anda mungkin dikehendaki menambah dana pada akaun anda?',
  ca_q17:
    '11. Indeks S&P 500 mempunyai harga belian $2700. Anda memutuskan untuk membuka dagangan CFD long (beli) sebanyak 2 kontrak. Leverage yang digunakan ialah 1:20. Anda menetapkan stop loss pada harga $2600 dan ambil untung pada harga $3000. Dengan mengandaikan baki pada akaun anda adalah mencukupi dan pesanan tidak berubah sehingga sama ada harga jualan henti rugi atau harga jualan ambil untung dicapai dan tiada caj tambahan dikenakan, apakah untung atau rugi yang akan anda tanggung pada akaun anda apabila kedudukan ditutup?',
  ca_q18: '1. Berapakah jumlah pendapatan tahunan anda?',
  ca_q19: '2. Apakah sumber pendapatan anda?',
  ca_q20: '3. Berapakah peratusan pendapatan tahunan anda yang berkaitan dengan kewajipan kewangan?',
  ca_q21: '4. Berapakah anggaran nilai Aset anda?',
  ca_q22: '5. Apakah struktur Aset anda?',
  ca_q23: '6. Berapakah anggaran Nilai Bersih anda (Jumlah Aset – Jumlah Liabiliti)?',
  ca_q24: '1. Sila pilih salah satu daripada pernyataan di bawah:',
  ca_q25: '2. Manakah antara pernyataan berikut yang lebih sesuai untuk anda?',
  ca_q26: '3. Manakah yang paling relevan dengan gaya pelaburan anda?',
  ca_q27: '4. Berdasarkan jangkaan anda, apakah turun naik tahunan nilai portfolio anda yang anda sanggup terima?',
  ca_q28: '5. Manakah antara pilihan berikut akan dianggap sebagai portfolio yang paling sesuai untuk anda?',
  ca_q29: '6. Apakah ufuk masa objektif pelaburan anda?',
  ca_q30: '7. Apakah matlamat pelaburan anda?',
  ca_q31: '8. Apakah tahap kecairan portfolio anda yang anda sanggup terima?',
  ca_q1_ao1: 'a) Ya, saya telah berdagang pada akaun real',
  ca_q1_ao2: 'b) Ya, saya telah berdagang pada akaun demo',
  ca_q1_ao3: 'c) Tidak, tetapi saya telah menggunakan perkhidmatan pelaburan Pengurusan Portfolio dan/atau Nasihat Pelaburan',
  ca_q1_ao4: 'd) Tidak, tetapi saya mempunyai pengetahuan yang luas melalui pendidikan saya (ijazah sarjana muda, ijazah sarjana dll.)',
  ca_q1_ao5: 'e) Tidak',
  ca_q2_ao6: 'a) 0 - 6 bulan',
  ca_q2_ao7: 'b) 6 - 12 bulan',
  ca_q2_ao8: 'c) 1 - 2 tahun',
  ca_q2_ao9: 'd) 2 - 4 tahun',
  ca_q2_ao10: 'e) Lebih 4 tahun',
  ca_q3_ao11: 'I. Tidak pernah',
  ca_q3_ao12: 'II. Jarang (kurang daripada 50 kali)',
  ca_q3_ao13: 'III. Kadang-kadang (50-100 kali)',
  ca_q3_ao14: 'IV. Kerap (lebih daripada 101 dagangan)',
  ca_q4_ao15: 'I. Tidak pernah',
  ca_q4_ao16: 'II. Jarang (kurang daripada 50 kali)',
  ca_q4_ao17: 'III. Kadang-kadang (50-100 kali)',
  ca_q4_ao18: 'IV. Kerap (lebih daripada 101 dagangan)',
  ca_q5_ao19: 'I. Tidak pernah',
  ca_q5_ao20: 'II. Jarang (kurang daripada 50 kali)',
  ca_q5_ao21: 'III. Kadang-kadang (50-100 kali)',
  ca_q5_ao22: 'IV. Kerap (lebih daripada 101 dagangan)',
  ca_q6_ao23: 'I. Tidak pernah',
  ca_q6_ao24: 'II. Jarang (kurang daripada 50 kali)',
  ca_q6_ao25: 'III. Kadang-kadang (50-100 kali)',
  ca_q6_ao26: 'IV. Kerap (lebih daripada 101 dagangan)',
  ca_q7_ao27: 'i. 0',
  ca_q7_ao28: 'ii. Kurang daripada €500',
  ca_q7_ao29: 'iii. €501 - €2,000',
  ca_q7_ao30: 'iv. €2,001 - €5,000',
  ca_q7_ao31: 'v. Lebih daripada €5,001',
  ca_q8_ao32: 'i. 0',
  ca_q8_ao33: 'ii. Kurang daripada €500',
  ca_q8_ao34: 'iii. €501 - €2,000',
  ca_q8_ao35: 'iv. €2,001 - €5,000',
  ca_q8_ao36: 'v. Lebih daripada €5,001',
  ca_q9_ao37: 'i. 0',
  ca_q9_ao38: 'ii. Kurang daripada €500',
  ca_q9_ao39: 'iii. €501 - €2,000',
  ca_q9_ao40: 'iv. €2,001 - €5,000',
  ca_q9_ao41: 'v. Lebih daripada €5,001',
  ca_q10_ao42: 'i. 0',
  ca_q10_ao43: 'ii. Kurang daripada €500',
  ca_q10_ao44: 'iii. €501 - €2,000',
  ca_q10_ao45: 'iv. €2,001 - €5,000',
  ca_q10_ao46: 'v. Lebih daripada €5,001',
  ca_q11_ao47: 'a. Penerimaan dan penghantaran dan/atau pelaksanaan pesanan (perkhidmatan pelaburan yang memerlukan keputusan bebas)',
  ca_q11_ao48: 'b. Nasihat pelaburan',
  ca_q11_ao49: 'c. Pengurusan portfolio',
  ca_q11_ao50: 'd. tiada',
  ca_q12_ao51: 'a. Saya mempunyai pengalaman profesional yang berkaitan',
  ca_q12_ao52: 'b. Saya sentiasa memantau berita/pasaran',
  ca_q12_ao53: 'c. Saya telah menghadiri seminar atau kursus berkaitan Pasaran Kewangan / Pelaburan / Online Trading',
  ca_q12_ao54: 'd. Tiada satu pun di atas',
  ca_q13_ao55: 'a. -€1,200',
  ca_q13_ao56: 'b. -€1,400',
  ca_q13_ao57: 'c. -€1,600',
  ca_q13_ao58: 'd. -€1,800',
  ca_q14_ao59: 'a. -€6,000',
  ca_q14_ao60: 'b. -€7,000',
  ca_q14_ao61: 'c. -€8,000',
  ca_q14_ao62: 'd. -€10,000',
  ca_q15_ao63: 'a. Melindungi anda daripada mengalami kerugian yang cepat',
  ca_q15_ao64: 'b. Hadkan pendedahan risiko anda',
  ca_q15_ao65: 'c. Memastikan anda tidak pernah mengalami kerugian dalam perdagangan',
  ca_q15_ao66: 'd. Melindungi anda daripada risiko menggunakan leverage',
  ca_q16_ao67: 'a. If the price of the underlying on an open position moves against you in order for your equity to move below your minimum maintenance margin.',
  ca_q16_ao68: 'b. Jika anda menanggung yuran transaksi yang menyebabkan akaun anda mengalami defisit.',
  ca_q16_ao69: 'c. Jika kedudukan CFD terbuka dikenakan caj semalaman yang menyebabkan akaun anda mengalami defisit.',
  ca_q16_ao70: 'd. Semua di atas.',
  ca_q17_ao71: 'a. -$100 or $300',
  ca_q17_ao72: 'b. -$200 or $600',
  ca_q17_ao73: 'c. -$2,000 or $6,000',
  ca_q17_ao74: 'd. -$4,000 or $12,000',
  ca_q18_ao75: 'a. Kurang daripada €20,000',
  ca_q18_ao76: 'b. Antara €20,000 dan €50,000',
  ca_q18_ao77: 'c. Antara €50,000 dan €100,000',
  ca_q18_ao78: 'd. Lebih daripada €100,000',
  ca_q19_ao79: 'a. Gaji/ Pencen',
  ca_q19_ao80: 'b. Dividen/ Faedah/ Kupon',
  ca_q19_ao81: 'c. Sewa',
  ca_q19_ao82: 'd. Derma/ Warisan',
  ca_q19_ao83: 'e. Sumber pendapatan lain',
  ca_q20_ao84: 'a. Kurang daripada 25%',
  ca_q20_ao85: 'b. Antara 25% dan 50%',
  ca_q20_ao86: 'c. Antara 50% dan 75%',
  ca_q20_ao87: 'd. Lebih daripada 75%',
  ca_q21_ao88: 'a. Kurang daripada €100,000',
  ca_q21_ao89: 'b. Antara €100,000 dan €500,000',
  ca_q21_ao90: 'c. Antara €500,000 dan €1,000,000',
  ca_q21_ao91: 'd. Lebih daripada €1,000,000',
  ca_q22_ao92: 'a. Terutamanya dalam deposit Bank',
  ca_q22_ao93: 'b. Terutamanya dalam Hartanah',
  ca_q22_ao94: 'c. Terutamanya dalam Instrumen Kewangan',
  ca_q22_ao95: 'd. Diperuntukkan sama rata dalam ketiga-tiga pilihan di atas',
  ca_q22_ao96: 'e. Lain',
  ca_q23_ao97: 'a. Kurang daripada €100,000',
  ca_q23_ao98: 'b. Antara €100,000 dan €500,000',
  ca_q23_ao99: 'c. Antara €500,000 dan €1,000,000',
  ca_q23_ao100: 'd. Lebih daripada €1,000,000',
  ca_q24_ao101: 'a. Saya hanya mengambil risiko yang boleh mengurangkan modal saya yang dilaburkan dalam keadaan yang melampau.',
  ca_q24_ao102: 'b. Saya boleh mempertaruhkan sebahagian daripada modal saya yang dilaburkan untuk mencapai pulangan yang lebih tinggi daripada purata.',
  ca_q24_ao103: 'c. Saya boleh mempertaruhkan sebahagian atau keseluruhan modal saya yang dilaburkan, dengan harapan saya akan mendapat pulangan yang lebih tinggi.',
  ca_q25_ao104:
    'a. Yang paling penting bagi saya ialah keselamatan modal saya. Oleh itu, untuk mengelakkan sebarang kerugian, saya bersedia untuk melepaskan pulangan yang lebih tinggi',
  ca_q25_ao105:
    'b. Untuk mendapatkan pulangan yang lebih tinggi daripada purata, saya menerima mengambil risiko yang lebih tinggi dan saya bersedia menerima sedikit pengurangan modal saya.',
  ca_q25_ao106: 'c. Untuk pulangan yang tinggi saya bersedia untuk mengambil risiko yang tinggi walaupun sebahagian atau keseluruhan modal saya berisiko.',
  ca_q26_ao107: 'a. Pemeliharaan modal',
  ca_q26_ao108: 'b. Pertumbuhan pendapatan',
  ca_q26_ao109: 'c. Spekulasi',
  ca_q26_ao110: 'd. Hedging',
  ca_q27_ao111: 'a. ± 5%',
  ca_q27_ao112: 'b. ± 10%',
  ca_q27_ao113: 'c. ± 25%',
  ca_q27_ao114: 'd. ± 50%',
  ca_q28_ao115: 'a. Yang akan menghasilkan pulangan 1 - 2% yang stabil pada tahun-tahun akan datang.',
  ca_q28_ao116: 'b. Yang akan menghasilkan pulangan antara -2% dan +10% pada tahun-tahun akan datang.',
  ca_q28_ao117:
    'c. Yang dijangka menghasilkan pulangan antara -15% dan +30% pada tahun hadapan dan mungkin membawa kepada kerugian melebihi jumlah yang dilaburkan di bawah keadaan yang melampau.',
  ca_q29_ao118: 'a. Sehingga 1 tahun',
  ca_q29_ao119: 'b. Antara 1 dan 3 tahun',
  ca_q29_ao120: 'c. Antara 3 dan 5 tahun',
  ca_q29_ao121: 'd. Lebih 5 tahun',
  ca_q30_ao122: 'a. Pengurusan mudah tunai jangka pendek untuk menampung perbelanjaan yang tidak dijangka.',
  ca_q30_ao123: 'b. Simpanan jangka panjang.',
  ca_q30_ao124: 'c. Dapatkan keuntungan yang tinggi walaupun berisiko kehilangan jumlah yang dilaburkan',
  ca_q31_ao125: 'a. Kurang daripada 25%',
  ca_q31_ao126: 'b. Antara 25% dan 50%',
  ca_q31_ao127: 'c. Antara 50% dan 75%',
  ca_q31_ao128: 'd. Lebih daripada 75%',
  passport_ple_different: 'Sekiranya negara tempat tinggal anda dan negara pengeluaran ID anda berbeza, sila upload Pasport anda.',
  live_account: 'Akaun Live',
  agree_terms_marketing: 'Saya bersetuju untuk menerima kemas kini pemasaran daripada Eurotrader (lihat <a href="{PRIVACY_URL}" target="_blank">Dasar Privasi</a> ).',
  data_policy_text:
    'Data anda selamat dengan kami dan anda boleh berhenti melanggan pada bila-bila masa. Dengan mengklik di bawah, anda mengesahkan bahawa anda telah membaca dan menerima <a href="{TERMS_CONDITIONS_URL}" target="_blank">T&amp;C</a> dan <a href="{RISK_DISCLOSURE_URL}" target="_blank"> pendedahan risiko</a> dan anda membenarkan kami menyimpan dan memproses maklumat peribadi anda.',
  live_tos_with_link: 'Saya telah membaca, memahami dan menerima terma dan syarat serta pendedahan amaran risiko <a href="{URL}" target="_blank">disini</a>.',
  must_agree_marketing_terms: 'Sila tandakan kotak pilihan untuk meneruskan ke langkah seterusnya',
  tick_checkboxes: 'Sila tandakan kotak pilihan untuk meneruskan',
  partner_account: 'Akaun Partner',
  privacy_policy: 'privacy policy',
  client: 'pelanggan',
  commission_amount: 'jumlah komisen',
  tier_name: 'nama peringkat',
  trades_completed: 'dagangan selesai',
  trade: 'perdagangan',
  pamm_investor_selection_note:
    "* Sila ambil perhatian 'Akaun pelabur' direka khusus untuk digunakan berkaitan dengan akaun Master dan tidak boleh didagangkan secara manual. Sila hubungi sokongan pelanggan jika anda ingin mengetahui lebih lanjut tentang akaun pelabur",
  bitpace_network_warning_BTC: 'Alamat ini adalah untuk deposit Bitcoin sahaja. Jangan hantar dari mana-mana rantai selain BTC atau deposit anda mungkin hilang',
  bitpace_network_warning_LTC: 'Alamat ini adalah untuk deposit Litecoin sahaja. Jangan hantar dari mana-mana rantai selain LTC atau deposit anda mungkin hilang',
  bitpace_network_warning_XRP: 'Alamat ini adalah untuk deposit Ripple sahaja. Jangan hantar dari mana-mana rantai selain XRP atau deposit anda mungkin hilang',
  bitpace_network_warning_BCH: 'Alamat ini adalah untuk deposit Bitcoin Cash sahaja. Jangan hantar dari mana-mana rantai selain BCH atau deposit anda mungkin hilang',
  bitpace_network_warning_USDT:
    'Sila gunakan rangkaian Ethereum (ERC20) atau TRON (TRC20) sahaja. Deposit anda akan hilang dan tidak boleh dipulihkan jika anda tidak menggunakan rangkaian yang ditentukan. Tolong jangan hantar dana melalui BSC, BEP20, BEP-2 atau rangkaian lain.',
  bitpace_network_warning_USDC:
    'Sila gunakan rangkaian Ethereum (ERC20) atau TRON (TRC20) sahaja. Deposit anda akan hilang dan tidak boleh dipulihkan jika anda tidak menggunakan rangkaian yang ditentukan. Tolong jangan hantar dana melalui BSC, BEP20, BEP-2 atau rangkaian lain.',
  bitpace_network_warning_TRX:
    'Sila gunakan rangkaian TRON (TRC20) sahaja. Deposit anda akan hilang dan tidak boleh dipulihkan jika anda tidak menggunakan rangkaian TRON. Tolong jangan hantar dana melalui BSC, BEP20, BEP-2 atau rangkaian lain.',
  bitpace_network_warning_LINK:
    'Sila gunakan rangkaian Ethereum (ERC20) sahaja. Deposit anda akan hilang dan tidak boleh dipulihkan jika anda tidak menggunakan rangkaian Ethereum. Tolong jangan hantar dana melalui BSC, BEP20, BEP-2, TRC atau rangkaian lain.',
  crypto_note_text:
    "Pelanggan yang dihormati,<br><br>Kami berbesar hati untuk berkongsi bahawa deposit dan pengeluaran kripto kami telah dikemas kini dengan pilihan syiling untuk dipilih, termasuk Ethereum, Ripple, Litecoin dan banyak lagi. Terima kasih banyak atas kesabaran anda, dan kami memohon maaf atas sebarang kesulitan yang timbul.<br><br><strong>Sila ambil perhatian: anda perlu mengklik pada 'Buat alamat' dan menyalin alamat terkini setiap kali anda ingin mendepositkan.</strong>",
  crypto_visit_page: 'Sentiasa lawati halaman ini untuk mendapatkan alamat crypto terkini sebelum mendepositkan.',
  pamm_statistics_text:
    'Statistik Pamm boleh didapati di kawasan Pelanggan PAMM kami. Jika anda mempunyai akaun PAMM, sila klik pautan di bawah untuk diubah hala, dan gunakan kelayakan akaun PAMM anda untuk log masuk.',
  leverage: 'Leverage',
  bitpace_network_warning_BTC_withdrawal: 'Sila pastikan alamat dompet yang dimasukkan adalah betul dan dalam BTC. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_LTC_withdrawal: 'Sila pastikan alamat dompet yang dimasukkan adalah betul dan dalam LTC. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_XRP_withdrawal:
    'Sila pastikan alamat dompet yang dimasukkan adalah betul dan ia dalam XRP. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_BCH_withdrawal: 'Sila pastikan alamat dompet yang dimasukkan adalah betul dan dalam BCH. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_USDT_withdrawal:
    'Sila pastikan alamat dompet yang dimasukkan adalah betul dan dalam rangkaian ERC20 atau TRC20 dan dalam USDT. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_USDC_withdrawal:
    'Sila pastikan alamat dompet yang dimasukkan adalah betul dan dalam rangkaian ERC20 atau TRC20 dan dalam USDC. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_TRX_withdrawal:
    'Sila pastikan alamat dompet yang dimasukkan adalah betul dan dalam rangkaian TRC20 dan dalam TRX. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
  bitpace_network_warning_LINK_withdrawal:
    'Sila pastikan alamat dompet yang dimasukkan adalah betul dan berada dalam rangkaian ERC20 atau TRC20 dan berada dalam LINK. Memasukkan alamat yang salah akan menyebabkan dana anda hilang.',
}



// WEBPACK FOOTER //
// ./src/locale/ms.js